<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form" @submit="handleSubmit">
        <a-row>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="友商名称" hasFeedback>
              <a-input
                placeholder="请输入友商名称"
                autoComplete="off"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入友商名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="统一社会信用代码" hasFeedback>
              <a-input
                placeholder="请输入统一社会信用代码"
                autoComplete="off"
                :disabled="!isEdit"
                v-decorator="['numberCode', { rules: [{ required: true, message: '请输入统一社会信用代码！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注" hasFeedback>
              <a-textarea
                placeholder="请输入备注"
                autoComplete="off"
                :disabled="!isEdit"
                v-decorator="['remark', { rules: [{ required: false, message: '请输入备注！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24" style="margin-top: 10px; text-align: right">
            <a-button
              type="primary"
              html-type="submit"
              style="margin-right:10px;"
              v-if="this.type !== this.$sysInfo.MODAL_VIEW"
            >提交</a-button>
            <a-button style="margin-right:10px;" @click="cancel">取消</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import { updateFriendBusiness } from '@/api/friendBusiness'
// import { addressOptions } from '@/utils/proviceData.js'
export default {
  name: 'EditProject',
  mounted () {},
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 800,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'friend_business' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      }
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (flag) {
        if (this.type === this.$sysInfo.MODAL_MODIFY) {
          this.setModelInfo()
        }
      }
    },
    setModelInfo () {
      const model = {
        name: this.model.name,
        numberCode: this.model.numberCode,
        remark: this.model.remark
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(model)
      })
    },
    // 提交表单
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...value }
          if (this.type === this.$sysInfo.MODAL_MODIFY) {
            params.id = this.model.id
          }
          updateFriendBusiness(params).then(res => {
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('refreshTable')
              this.open(false)
            } else {
              this.$message.error(res.info.message)
            }
          })
        }
      })
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
  }
}
</script>

<style scoped lang="less">
.downloadList {
  margin-top: 10px;
  list-style: none;
  li {
    margin: 10px;
  }
}
</style>
